import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import FolderOpenOutlinedIcon from "@material-ui/icons/FolderOpenOutlined";
import FileItem from "./ResourceFileItem";
import DropZone from "./ResourceDropZone";

const BLUE = "#3B82F6";
const TEXT = "#1a1d2e";

const useStyles = makeStyles(() => ({
  sectionTitle: {
    display: "flex",
    alignItems: "center",
    gap: 7,
    fontSize: 13,
    fontWeight: 600,
    color: TEXT,
    marginBottom: 12,
    "& svg": { color: BLUE, fontSize: 18 },
  },
}));

export default function UploadStage({ files, onFilesAdded, onRemove, onAnalyze }) {
  const cls = useStyles();

  const handleFilesAdded = (fileList) => {
    onFilesAdded(fileList);
    // onAnalyze();
  };

  return (
    <>
      <div className={cls.sectionTitle}>
        <FolderOpenOutlinedIcon />
        <span>Resources</span>
      </div>

      <div>
        {files.map((f, i) => (
          <FileItem key={f.name} file={f} onRemove={() => onRemove(i)} />
        ))}
      </div>

      <DropZone onFilesAdded={handleFilesAdded} />
    </>
  );
}